var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoldEditForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,2C4.5,2,3,4,3,7v10c0,3,1.5,5,5,5h8c3.5,0,5-2,5-5V7c0-3-1.5-5-5-5H8z M16.5,9.2c-1.5,0-2.8-1.2-2.8-2.8 v-2c0-0.4,0.3-0.8,0.8-0.8s0.8,0.3,0.8,0.8v2c0,0.7,0.6,1.2,1.2,1.2h2c0.4,0,0.8,0.3,0.8,0.8s-0.3,0.8-0.8,0.8H16.5z M9.6,17.5 l-1,0.1c0,0-0.1,0-0.1,0c-0.1,0-0.3,0-0.4-0.1C8,17.4,7.9,17.2,8,17l0.2-1c0,0,0-0.1,0.1-0.1l1.7-1.7c0,0.1,0.1,0.1,0.1,0.2 c0,0.1,0.1,0.2,0.1,0.2c0,0.1,0.1,0.1,0.1,0.2c0,0.1,0.1,0.1,0.1,0.1c0,0,0,0,0,0.1c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0,0,0,0 c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.1,0.1,0.2,0.1s0.2,0.1,0.2,0.1l-1.7,1.7C9.7,17.5,9.7,17.5,9.6,17.5z M11.8,15.4C11.8,15.4,11.8,15.4,11.8,15.4c-0.1,0-0.1,0-0.1,0c-0.7-0.2-1.3-0.8-1.5-1.5c0,0,0-0.1,0-0.1l0.3-0.3 c0.5-0.5,1.1-0.5,1.6,0c0.3,0.3,0.4,0.5,0.4,0.8c0,0.3-0.1,0.5-0.4,0.8L11.8,15.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoldEditForm);
export default __webpack_public_path__ + "static/media/bold-edit-form.f42b8aa56c7cd21d8a057b0c62b45350.svg";
export { ForwardRef as ReactComponent };